import React,{useEffect} from 'react';
import { Helmet } from 'react-helmet-async';
import { Container } from '@mui/material';
import { useLocation } from 'react-router-dom';

import DocumentDetail from '../landingPage/page/Documentation/DocumentDetail';

export default function DocumentationPage() {

  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const element = document.querySelector(location.hash);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }, [location]);

  return (
    <>
      <Helmet>
        <title>WatchNod Documentation | Server Monitoring Setup & Guide</title>
        <meta
          name="description"
          content="Explore WatchNod documentation to learn server monitoring setup, performance tracking, uptime monitoring, and alerts for reliable infrastructure management."
        />
        <meta
          name="keywords"
          content="WatchNod Documentation, User Guide, Features, Settings, Tutorials, Help Center"
        />
      </Helmet>

      <Container maxWidth="xl">
        <DocumentDetail />
      </Container>
    </>
  );
}
